// SPDX-FileCopyrightText: 2026 Angels' Ware
// SPDX-License-Identifier: AGPL-3.0-or-later


export const SITE = "https://dazyflow.app";
export const DOCS = "https://docs.dazyflow.app";

export const SOURCE = "https://github.com/dazyflow/dazyflow";

export const LICENSE = "https://github.com/dazyflow/dazyflow/blob/master/LICENSE";

export const CONTACT = "mailto:hi@dazyflow.app";

export const INVITE = "mailto:hi@dazyflow.app?subject=Dazyflow%20early%20access";

// The year on a footer's copyright line. A constant rather than
// `new Date().getFullYear()`: the build is what is copyrighted, and a footer
// that silently rolls over on 1 January claims a year the code has not been
// touched in.
export const COPYRIGHT_YEAR = 2026;
